import React from 'react';
import { useParams } from 'react-router-dom';
import { number, object, string } from 'yup';

import { useToast } from 'Component/Alerta';
import BotaoLink from 'Component/BotaoLink';
import Form, { Botao as BotaoForm, Campo } from 'Component/Form';
import Icone from 'Component/Icone';
import ConsultorioInterface from 'Interface/Consultorios';
import { MASCARA_TELEFONE } from 'View/constants';
import {
  useAdicionarConsultorioMutation,
  useEditarConsultorioMutation,
  useRecuperarConsultoriosQuery,
} from 'View/Service/Default/Consultorios';

const regras = object({
  consultorio: string().required('Obrigatório'),
  medico: string().nullable().optional(),
  endereco: string().required('Obrigatório'),
  telefone: string().required('Obrigatório'),
  valor: number().required('Obrigatório'),
  atendimento: string().required('Obrigatório'),
});

const Consultorio = (): React.ReactElement => {
  const toast = useToast();
  const { id = 0 } = useParams();
  const [adicionarConsultorio] = useAdicionarConsultorioMutation();
  const [editarConsultorio] = useEditarConsultorioMutation();

  const {
    data: { consultorios: [consultorio] } = {
      consultorios: [{} as ConsultorioInterface],
    },
    isLoading,
  } = useRecuperarConsultoriosQuery({
    options: { empresa_id: id },
  });

  const enviar = async (dados: ConsultorioInterface): Promise<void> => {
    try {
      if (dados.id) {
        await editarConsultorio(dados).unwrap();
      } else {
        await adicionarConsultorio({ ...dados, empresa_id: id as number }).unwrap();
      }

      toast({ conteudo: 'Editado com sucesso!', tema: 'success' });
    } catch (error) {
      toast({
        titulo: 'Erro ao editar',
        conteudo: 'Verifique os logs para maiores detalhes.',
        tema: 'danger',
      });
    }
  };

  return (
    <Form
      onSubmit={enviar}
      inicial={consultorio}
      desabilitado={isLoading}
      regras={regras}
    >
      <div className="row">
        <div className="col-md-12">
          <div className="bg-white shadow-sm rounded p-4">
            <div className="row">
              <div className="col-md-12">
                <Campo name="consultorio" rotulo="Consultório médico" />
              </div>
              <div className="col-md-6">
                <Campo name="medico" rotulo="Nome do médico" />
              </div>
              <div className="col-md-6">
                <Campo name="endereco" rotulo="Endereço do consultório" />
              </div>
              <div className="col-md-6">
                <Campo
                  name="telefone"
                  rotulo="Telefone"
                  mascara={MASCARA_TELEFONE}
                  prefixar={<Icone nome="phone" />}
                />
              </div>
              <div className="col-md-6">
                <Campo
                  name="valor"
                  rotulo="Valor do exame"
                  prefixar={<Icone nome="cash-coin" />}
                />
              </div>
              <div className="col-md-12">
                <Campo name="atendimento" rotulo="Horário de atendimento" />
              </div>
            </div>

            <div className="mt-5">
              <BotaoForm>Enviar</BotaoForm>
              <BotaoLink tema="light" to="/clientes" className="ms-2">
                Cancelar
              </BotaoLink>
            </div>
          </div>
        </div>
      </div>
    </Form>
  );
};

export default Consultorio;
